import { ActivitySearchResult } from 'types';
import { Box, Grid, Text, Center, Group, Flex, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { Pebbles } from '@ui';
import classes from './ActivityListings.module.scss';
import { handleSelection } from 'utils/filters/filters';
import ActivityCardEmbed from '../ActivityCard/ActivityCardEmbed';
import { LightbulbFilament } from '@phosphor-icons/react';

interface IActivityListingsProps {
  activities: ActivitySearchResult[];
  error: boolean;
  postcode?: string;
  place?: string;
  mapSelectedActivities?: ActivitySearchResult[];
  loading?: boolean;
}

const ActivityListingsEmbed: React.FC<IActivityListingsProps> = (props) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { activities, error, loading } = props;

  const theme = useMantineTheme();

  if (error) {
    return (
      <div role="alert" aria-label="Error retrieving activities">
        Something went wrong retrieving activities. Please try again.
      </div>
    );
  }

  if (loading) {
    return (
      <Center style={{ height: '50vh' }}>
        <Pebbles data-testid="pebbles" />
      </Center>
    );
  }

  return (
    <div>
      <Box mb={0}></Box>
      {activities.length === 0 ? (
        <Flex direction="column" justify="space-between" className={classes.noActivitiesWrapper}>
          <Group className={classes.tipBox}>
            <LightbulbFilament
              size={isMobile ? 55 : 32}
              color={theme.colors.blue[6]}
              weight="regular"
              width={isMobile ? 'fit-content' : '32px'}
            />
            <div className={classes.flexColumn}>
              <Text className={classes.noActivitiesText} pb="sm">
                {' '}
                Unfortunately we can't find any activities near this location with the current
                filter settings.
              </Text>
              <Text size="md" py="xs">
                <span style={{ fontWeight: 'bold' }}>Tip!</span> Try expanding the search radius or
                show{' '}
                <a
                  role="link"
                  className={classes.onlineSwitch}
                  onClick={() => {
                    handleSelection(true.toString(), 'isOnline', () => {});
                  }}
                >
                  online activities
                </a>
              </Text>
            </div>
          </Group>
          <Text className={classes.registerLink} mt="xl">
            Click this{' '}
            <a href="https://forms.gle/cS3mqNnYrj5w5nQHA" target="_blank">
              link
            </a>{' '}
            to register your interest and we will do our best to bring Pebble Activities to your
            area soon!
          </Text>
        </Flex>
      ) : (
        <Grid
          gutter="xl"
          columns={2}
          justify={isMobile ? 'center' : 'flex-start'}
          className={classes.grid}
          w="100%"
          px={isMobile ? 10 : 'auto'}
        >
          {activities.map((activity) => (
            <Grid.Col
              key={activity.id}
              span={{ xs: 2, sm: 1 }}
              px={isMobile ? 0 : 'auto'}
              className={classes.gridCol}
            >
              <ActivityCardEmbed activity={activity} />
            </Grid.Col>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default ActivityListingsEmbed;
